import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const meKey = ["me"] as const;
export const orgUsersKey = ["orgUsers"] as const;

/**
 * Current user + org. Cached aggressively — invalidated by Clerk session
 * change downstream of the auth wrapper.
 */
export function useMe() {
  return useQuery({
    queryKey: meKey,
    queryFn: () => api.me(),
    staleTime: 60_000,
  });
}

/**
 * Org member list, used by assignee/owner pickers (Requirements Tracker,
 * Drafts, etc.). Refetched on focus to pick up newly invited teammates.
 */
export function useOrgUsers() {
  return useQuery({
    queryKey: orgUsersKey,
    queryFn: () => api.listOrgUsers(),
    staleTime: 30_000,
  });
}
